import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import services from '../../api/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const TextEditor = (props) => {
  const {
    onEditorChange,
    value,
    editorHeight,
    className,
    style,
    isDisabled,
    ...restProp
  } = props;

  const Font = ReactQuill.Quill.import('formats/font');
    Font.whitelist = [
      'arial', 
      'times-new-roman', 
      'courier-new', 
      'georgia', 
      'verdana',
      'tahoma',
      'roboto',
      'open-sans',
      'comic-sans',
      'impact'
    ];
  return (
    <div className={className} style={style}>
      {/* <Editor
        apiKey="olvo9xapc1lfyi6rq6kfc2o9o3dhv35urx88j82chqld8g1t"
        // onInit={(evt, editor) => console.log('editor', editor)}
        onEditorChange={onEditorChange}
        value={value}
        init={{
          height: editorHeight,
          // setup: () => {
          //   console.log('set up called');
          // },
          menubar: false,
          plugins:
            "hr lists table fullscreen emoticons preview searchreplace insertdatetime directionality charmap link autolink image media",
          toolbar:
            'undo redo selectall link image media|' +
            'bold italic underline strikethrough  |' +
            'blocks fontfamily fontsize |' +
            'forecolor backcolor |' +
            'alignleft aligncenter alignright alignjustify |' +
            'outdent indent ' +
            'numlist bullist checklist |' +
            'charmap emoticons searchreplace |' +
            'subscript superscript hr |' +
            'removeformat |' +
            'table insertdatetime |' +
            'fullscreen PrintReorder print preview |' +
            // 'a11ycheck permanentpen formatpainter casechange' +
            'ltr rtl',
          branding: false,
          images_upload_handler: async (blobInfo, progress) => {
            return new Promise((resolve, reject) => {
              const formData = new FormData();
              formData.append('photos', blobInfo.blob(), blobInfo.filename());

              services
                .uploadImage(formData)
                .then((res) => {
                  if (res.data.data.photos.length && res.data.data.photos[0]) {
                    progress(100);
                    resolve(res.data.data.photos[0].location);
                  } else {
                    reject('Failed to retrieve image URL.');
                  }
                })
                .catch((err) => {
                  console.log(err);
                  reject('Image upload failed. Please try again.');
                });
            });
          },
          content_style:
            'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
          ...restProp,
        }}
        disabled={isDisabled}
      /> */}

      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={(value, editor) =>
          onEditorChange(value)
        }
        modules={{
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],
            ['link', 'image', 'video', 'formula'],
            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction
          
            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          
            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'font': Font.whitelist }],
            [{ 'align': [] }],
            ['clean']                                         // remove formatting button
          ]
        }}
      />
    </div>
  );
};

export default TextEditor;
